import api from '../../api/axiosInstance';
import { APP_SETTINGS } from "../../../../config";

const getAuthHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const createOvertimeRequestApi = (requestData, token) => {
  return api.post(
    APP_SETTINGS.API_PATH.OVERTIME.create,
    requestData,
    getAuthHeaders(token)
  );
};

export const getOvertimeRequestByIdApi = (id, token) => {
  return api.get(
    `${APP_SETTINGS.API_PATH.OVERTIME.getById}/${id}`,
    getAuthHeaders(token)
  );
};

export const getAllOvertimeRequestsApi = (filters, token) => {
  return api.get(APP_SETTINGS.API_PATH.OVERTIME.getAll, { 
    params: filters,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateOvertimeStatusApi = (id, statusData, token) => {
    return api.patch(
        `${APP_SETTINGS.API_PATH.OVERTIME.updateStatus}/${id}/status`, 
        statusData,
        getAuthHeaders(token)
    );
};


export const updateOvertimeRequestApi = (id, requestData, token) => {
    return api.put(
        `${APP_SETTINGS.API_PATH.OVERTIME.update}/${id}`, 
        requestData,
        getAuthHeaders(token)
    );
};

export const deleteOvertimeRequestApi = (id, token) => {
    return api.delete(
        `${APP_SETTINGS.API_PATH.OVERTIME.delete}/${id}`,
        getAuthHeaders(token)
    );
};